<template lang="">
  <v-dialog v-model="dialog" width="700px">
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title>THÊM ÁP DỤNG</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" flat lazy-validation>
          <v-row>
            <v-col cols="12">
              <v-radio-group v-model="groupFee" class="small-radio style" :rules="[rules.required]" row>
                <v-radio label="Chung cho cả nhóm đối tượng" value="group"></v-radio>
                <v-radio label="Riêng từng đối tượng cụ thể" value="select"></v-radio>
              </v-radio-group>
            </v-col>

            <v-col cols="6" v-if="groupFee === 'group'">
              <v-autocomplete
                v-model="tuitionGroup"
                clear-icon="mdi-close"
                :items="tuitionGroups"
                item-text="title"
                item-value="id"
                label="Nhóm đối tượng áp dụng"
                clearable
                outlined
                dense
                return-object
                required
                :rules="[rules.required]"
                class="required style"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-divider></v-divider>
              <v-radio-group v-model="regulations" class="small-radio" row :rules="[rules.required]">
                <v-radio label="Thu theo Năm" value="year"></v-radio>
                <v-radio label="Thu theo Học Kỳ" value="semester"></v-radio>
                <v-radio label="Thu theo Tháng" value="month"></v-radio>
                <v-radio label="Thu theo Đợt" value="custom"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" v-if="groupFee === 'group' && regulations === 'month'">
              <v-divider class="mb-2" />
              <headFeeDetailPriceEachMonth ref="price-per-month" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mt-5">
        <v-btn depressed outlined color="grey darken-1" class="px-6 ml-4 mt-n4 mb-2 white--text" @click="cancel"
          >Hủy</v-btn
        >
        <v-spacer />
        <v-btn
          depressed
          class="px-6 mr-4 mt-n4 mb-2 white--text"
          :loading="loading"
          :disabled="loading"
          color="primary"
          @click="save"
        >
          Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { inputRules } from '@/plugins/rule'
import headFeeDetailPriceEachMonth from './headFeeDetailPriceEachMonth.vue'
import { get } from 'lodash'

export default {
  components: { headFeeDetailPriceEachMonth },
  props: {
    state: Boolean,
    headfee: Object,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      groupFee: '',
      regulations: '',
      tuitionGroup: '',
      rules: inputRules,
      isBtnSave: false,
      prices: {},
    }
  },
  created() {
    this.setRouter(this.pathName)
    this.fetchTuitionGroup({ type: this.router, _limit: -1 })
  },
  computed: {
    ...mapState('tuitonFeeHeadFee', ['tuitionGroups', 'router']),
    pathName() {
      return this.$route.name
    },
  },
  methods: {
    ...mapActions('tuitonFeeHeadFee', ['fetchTuitionGroup', 'createGroupHeadFee', 'setRouter']),
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    },
    validate() {
      return this.$refs.form.validate()
    },
    async save() {
      this.loading = true
      if (this.validate()) {
        try {
          this.isBtnSave = true
          let payload = {
            period: this.regulations,
            scope: this.groupFee,
            group: get(this.tuitionGroup, 'id'),
            head_fee: this.headfee.id,
          }
          if (this.groupFee === 'group' && this.regulations === 'month') {
            payload['prices'] = await this.$refs['price-per-month'].getData()
          }
          let oneGroupHeadFee = await this.createGroupHeadFee(payload)
          if (oneGroupHeadFee) {
            this.$refs.form.reset()
            this.dialog = false
            document.getElementById('list-item-' + oneGroupHeadFee.id).scrollIntoView({ behavior: 'smooth' })
          }
        } catch (error) {
          this.$alert.addError(error)
        }
      }
      this.loading = false
    },
  },
  watch: {
    state() {
      this.dialog = true
    },
    pathName() {
      this.setRouter(this.pathName)
    },
  },
}
</script>
<style lang="scss" scoped>
.small-radio i {
  font-size: 19px;
}
.small-radio label {
  font-size: 14px;
  padding-left: 0px;
  margin-left: -4px;
}
.small-radio .v-radio {
  padding: 0px;
}
.style {
  margin-bottom: -19px !important;
}
.v-list {
  max-width: 60vh;
}
</style>
